import { FunnelIcon, useEffect, useCallback } from "@";

/**
 * A component to render a search input with a toggle button
 * @param {{ children: React.ReactNode, toggle: () => void }} props
 * @prop {React.ReactNode} children The search input
 * @prop {() => void} toggle The toggle button click handler
 * @returns {JSX.Element}
 */
const Search = ({ children, toggle }) => {
  const handleKeyPress = useCallback((event) => {
    if (event.altKey && event.key === "s") {
      document.getElementById("search-toggle").click();
    }
  }, []);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <div id="search-input" className="relative flex items-center gap-3">
      {children}

      {toggle && (
        <>
          <button
            type="button"
            id="search-toggle"
            onClick={toggle}
            className="btn-white flex items-center justify-center"
          >
            <FunnelIcon className="h-5 w-5 transition-transform group-hover:scale-110" />

            <span className="hidden md:inline">تصفية النتائج</span>
          </button>
        </>
      )}
    </div>
  );
};

export default Search;
